module.exports = __webpack_public_path__ + "img/logo-2023.c1b6ebff.svg";